(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.regionbar = window.oneadvanced.regionbar || {};
    window.oneadvanced.regionbar.init = function () {
        //       Session Cookie to check if user has already dismissed the Region Bar
        //       Maxmind API to detect Country associated with user's IP address

        //       Logic:
        //         Check if Region Bar has previously been dismissed
        //             Check User Location
        //                 if Site Country Code does not match that of the User
        //                     Create and display Region Bar
        //                     else do nothing

        let suppressRegionBar = sessionStorage.getItem('suppressRegionBar'); // returns null if not set
        if (suppressRegionBar === null) {
            //console.log("Region Bar Suppress Indicator not found, checking location...");
            window.oneadvanced.regionbar.checklocation();
        }
    };

    window.oneadvanced.regionbar.checklocation = function () {
        window.oneadvanced.regionbar.onsuccess = function (geoipResponse) {
            //console.log(geoipResponse);
            if (geoipResponse.country.iso_code != window.oneadvanced.regionbar.countrycode) {
                window.oneadvanced.regionbar.createbar();
            }
        };

        window.oneadvanced.regionbar.onerror = function (geoipResponse) {
            console.log(geoipResponse);
        };

        if (typeof geoip2 !== 'undefined') {
            geoip2.country(window.oneadvanced.regionbar.onsuccess, window.oneadvanced.regionbar.onerror);
        } else {
            console.log("GeoIP2 is blocked.");
        }
    };

    window.oneadvanced.regionbar.createbar = function () {
        const regionbarCallout = document.createElement("div");
        regionbarCallout.className = "regionbarblock__callout";
        regionbarCallout.dataset.closable = "slide-in-down slide-out-up";

        const flag = document.createElement("img");
        flag.src = window.oneadvanced.regionbar.flagicon;
        flag.setAttribute("width", "18px");
        flag.setAttribute("height", "18px");
        flag.className = "regionbarblock__flag";

        const message = document.createElement("div");
        message.className = "regionbarblock__message";
        message.innerHTML = window.oneadvanced.regionbar.message;

        const selectContainer = document.createElement("div");
        selectContainer.className = "regionbarblock__selectcontainer";

        const label = document.createElement("label");
        label.setAttribute("for", "regionbarblock__select");
        label.className = "show-for-sr";
        label.innerHTML = "Region Select";

        const focus = document.createElement("span");
        focus.className = "regionbarblock__selectfocus";

        window.oneadvanced.regionbar.handleSelectChange = function (event) {
            console.log("on change");
            var selectElement = event.target;
            var value = selectElement.value;

            window.location.href = value;
        };

        const select = document.createElement("select");
        select.className = "regionbarblock__select";
        select.id = "regionbarblock__select";
        select.onchange = window.oneadvanced.regionbar.handleSelectChange;
        select.addEventListener('change', window.oneadvanced.regionbar.handleSelectChange);

        if (Array.isArray(window.oneadvanced.regionbar.sites)) {
            for (var i = 0; i < window.oneadvanced.regionbar.sites.length; i++) {
                const opt = document.createElement("option");
                opt.value = window.oneadvanced.regionbar.sites[i].URL;
                opt.text = window.oneadvanced.regionbar.sites[i].Name;
                select.add(opt, null);
            }
        }

        window.oneadvanced.regionbar.handleCTAClick = function () {
            //console.log("on click");
            window.location.href = document.getElementById("regionbarblock__select").value;
        };

        const cta = document.createElement("a");
        cta.className = "btn monochrome-dark";
        cta.innerText = window.oneadvanced.regionbar.cta;
        cta.addEventListener("click", window.oneadvanced.regionbar.handleCTAClick);

        window.oneadvanced.regionbar.handleDismissClick = function () {
            sessionStorage.setItem('suppressRegionBar', true);
        };

        const closeButton = document.createElement("button");
        closeButton.className = "close-button";
        closeButton.setAttribute("aria-label", "Dismiss Region Selector");
        closeButton.setAttribute("type", "button");
        closeButton.dataset.close = "";
        closeButton.addEventListener("click", window.oneadvanced.regionbar.handleDismissClick);

        const ariaSpan = document.createElement("span");
        ariaSpan.setAttribute("aria-hidden", true);
        ariaSpan.innerHTML = "&times;";

        // put it all together
        // 1) Flag
        // 2) Message
        // 3) Select
        // 4) CTA
        regionbarCallout.appendChild(flag);
        regionbarCallout.appendChild(message);
        selectContainer.appendChild(label);
        selectContainer.appendChild(select);
        selectContainer.appendChild(focus);
        regionbarCallout.appendChild(selectContainer);
        regionbarCallout.appendChild(cta);
        closeButton.appendChild(ariaSpan);
        regionbarCallout.appendChild(closeButton);

        document.body.prepend(regionbarCallout);
    };

    window.oneadvanced.regionbar.hasLoaded = true;
})();